export enum SigningContext {
    SignerService = "SignerService",
    PhysicalToken = "PhysicalToken"
}

